/**
 * @version 1.0.1
 * @author yangf
 * @createTime:2021-10-08,
 * @updateTime:2021-10-08
 * @copyright thunisoft fd
 */

import pieEcharts from '@/components/app/pieEcharts/index.vue';
import barEcharts from '@/components/app/barEcharts/index.vue';
import barPortraitEcharts from '@/components/app/barPortraitEcharts/index.vue';
import barRedEcharts from '@/components/app/barEcharts02/index.vue';
import mapEcharts from '@/components/app/chinaMapEcharts/index.vue';
import fdDataTable from '../../../../js/app/dataTable/fdDataTable';
import mtdMixins from '@/pages/mixins/index.js';
export default {
    name: 'pmfx',
    components: {pieEcharts, barEcharts, mapEcharts, barRedEcharts, barPortraitEcharts},
    mixins:[mtdMixins],
    data() {
        return {
            pmztfxTotal:[{
                name:'正在进行',
                value:60
            }, {
                name:'即将开始',
                value:60
            }],
            // 海事法院code和省份的对照表
            hsfyCode:fdDataTable.hsfyCode,
            // 拍卖状态分析
            tablePmztfx:[],
            // 成交标的物种类
            cjbdwzData:[],
            // 成交标的物金额
            cjbdwjeData:[],
            // 标的物拍卖阶段
            bdwpmjdData:[],
            // 标的物拍卖溢价率
            bdwpmyjlData:[],
            data: '',
            // 查询条件
            searchData:{tjsj:''},
            month:null,
            date:null,
            minute:null
        };
    },
    mounted() {
        this.initYear();
        this.init();
    },
    methods: {
        // 点击查询
        clickSearch() {
            this.init();
        },
        initYear() {
            this.dealYear(5);
            this.$nextTick(() => {
                this.searchData.tjsj = this.yearList[1].code.toString();
            });
        },
        // 重置
        resetSearch() {
            // 清空数据
            this.searchData.tjsj = this.yearList[1].code.toString();
            // 请求
            this.clickSearch();
        },
        // 获取初始化数据
        init() {
            if (!this.searchData.tjsj) {
                this.searchData.tjsj = (new Date().getFullYear() - 1)
                    .toString();
            }
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.kypm.pmfx,
                params: {tjsj: this.searchData.tjsj}
            }).then((res) => {
                this.initTablePmztfx(res.data.pmfxHsfyTjVOList);
                this.initDate();
                this.pmztfxTotal = [{
                    name:'正在进行',
                    value:res.data.zzjxTotal
                }, {
                    name:'即将开始',
                    value:res.data.jjksTotal
                }];

                /*
                * 第一个参数为后台返回的需要处理的数据
                * 第二个参数为图标显示的名称
                * 第三个参数为图标显示的值
                * 第四个参数为是否需要换算单位
                */
                // 标的物种类
                this.cjbdwzData = this.handleTop5(res.data.pmfxBdwVOList, 'bdlbTranslateText', 'bdwCount');
                // 标的物金额
                res.data.pmfxBdwVOList.forEach(item => {
                    // 可能没有返回数据，默认为0
                    if (!item.bdwMoney) {
                        item.bdwMoney = 0;
                    } else {
                    // 四舍五入保留两位
                        item.bdwMoney = Math.round(item.bdwMoney / 10000 * 100) / 100;
                    }
                });
                this.cjbdwjeData = this.handleTop5(res.data.pmfxBdwVOList, 'bdlbTranslateText', 'bdwMoney', true);

                // this.cjbdwjeData = _data1;
                // 拍卖阶段
                const _data2 = [];
                res.data.pmfxPmjdVOList.forEach((item) => {
                    _data2.push({
                        name:item.pmjdTranslateText,
                        value:item.pmjdCount
                    });
                });
                this.bdwpmjdData = _data2;
                // 溢价率
                const _data3 = [];
                res.data.pmfxYjlVOList.forEach((item) => {
                    // 溢价率可能没有，没有不展示
                    if (item.yjl) {
                        _data3.push({
                            name:item.yjl,
                            value:item.yjlCount
                        });
                    }
                });
                this.bdwpmyjlData = _data3;
            });
        },
        // 处理只展示top5+其他
        handleTop5(data, name, key, conversion) {
            let copyData = [...data];
            // 需要返回的数据
            const rtData = [];
            // 其他类总数
            let pmfxBdwVOTotal = 0;
            // 需要筛选的数据(其他财产类)
            let filterData = null;
            const filteDataIndex = data.findIndex(item => item.bdlb === '255');
            if (filteDataIndex !== -1) {
                // 将筛选出来的保存
                filterData = copyData.splice(filteDataIndex, 1);
                pmfxBdwVOTotal += Number(filterData[0][key]);
            }
            // splice会改变原数组，所以当前数组已经没有其他财产类
            copyData = copyData.sort(this.compare(key));
            copyData.forEach((item, index) => {
                // 可能没有返回数据，默认为0
                if (!item[key]) {
                    item[key] = 0;
                }
                // 只展示前五
                if (index < 5) {
                    rtData.push({
                        name:item[name],
                        value:item[key]
                    });
                } else {
                    // 大于五展示为其他
                    pmfxBdwVOTotal += Number(item[key]);
                }
            });
            if (pmfxBdwVOTotal) {
                if (conversion) {
                    // 四舍五入保留两位
                    pmfxBdwVOTotal = Math.round(pmfxBdwVOTotal * 100) / 100;
                }
                rtData.push({
                    name:'其他',
                    value:pmfxBdwVOTotal
                });
            }
            return rtData;
        },
        // 排序
        compare(property) {
            return function (a, b) {
                const value1 = a[property];
                const value2 = b[property];
                return value2 - value1;
            };
        },
        // 更新时间
        initDate() {
            const _day = new Date();
            this.month = _day.getMonth() + 1;
            this.date = _day.getDate();
            this.minute = `${_day.getHours()}:${_day.getMinutes()}`;
        },
        initTablePmztfx(data) {
            const _data = [];
            data.forEach((item) => {
                _data.push({
                    title:item.fy,
                    name:this.hsfyCode[item.fydm],
                    zzjx:item.zzjxCount,
                    jjks:item.jjksCount
                });
            });
            this.tablePmztfx = _data;
        }
    }
};

